// HKDSE Type D (抒情散文) Q&A Data
// D1. 范仲淹《岳陽樓記》
// D2. 柳宗元《始得西山宴遊記》

export const hkdseTypeDQAData = {
  'hkdse-d1-fanzhongyan-yueyanglou-ji': {
    title: '范仲淹《岳陽樓記》問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '應試結構圖',
            points: [
              {
                title: '各段內容重點',
                items: [
                  '第一段：交代寫作緣起及背景（滕子京謫守巴陵，重修岳陽樓，囑作者為文記之）。',
                  '第二段：描述洞庭湖及岳陽樓的壯麗景色，並指出「遷客騷人」因景生情。',
                  '第三段：描寫陰雨惡劣天氣時的景象（霪雨霏霏、陰風怒號、濁浪排空），遷客騷人登樓則「去國懷鄉，憂讒畏譏，滿目蕭然，感極而悲」。',
                  '第四段：描寫春和景明、湖光山色、萬里晴空時的景象（沙鷗翔集、岸芷汀蘭、浮光躍金），登樓者「心曠神怡，寵辱皆忘，把酒臨風，其喜洋洋」。',
                  '第五段：提出古仁人之心，主張「不以物喜，不以己悲」，強調「先天下之憂而憂，後天下之樂而樂」的精神境界。'
                ]
              }
            ]
          },
          {
            subtitle: '心境分析整理',
            points: [
              {
                title: '晴天登樓',
                items: [
                  '景色壯麗（朝暉夕陰、氣象萬千、浩浩湯湯、橫無際涯），',
                  '登樓者心情開朗，心曠神怡，把酒臨風，寵辱皆忘。'
                ]
              },
              {
                title: '陰天登樓',
                items: [
                  '景色蕭瑟（霪雨連綿、濁浪排空、虎嘯猿啼），',
                  '登樓者多懷憂愁，去國懷鄉，感極而悲。'
                ]
              }
            ]
          }
        ]
      },
      centralTheme: {
        title: '主旨及精神',
        content: [
          '作者藉岳陽樓的景色，反思人生起伏與宦海沉浮，感嘆人心易受環境影響。',
          '強調古仁人精神：「不以物喜，不以己悲」，勉勵友人與後人以天下為己任，「先天下之憂而憂，後天下之樂而樂」，展現憂國憂民的抱負。'
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '根據首段，作者表明寫作《岳陽樓記》的動機是什麼？（3分）',
            answer: '作者受滕子京之託，為重修岳陽樓作記，既記盛事，也抒發自身與友人的懷抱和志向，藉此勉勵友人及後人。'
          },
          {
            question: '從本文內容可見，作者對政治有何態度？',
            answer: '作者關心民生，憂國憂民，無論身居廟堂或被貶江湖，都能心懷國家與百姓福祉，體現「先天下之憂而憂，後天下之樂而樂」的情操。'
          },
          {
            question: '文章如何描述不同天氣下登樓者的心境？',
            answer: '晴天：景明水闊，心情開朗，心曠神怡，寵辱皆忘。陰天：風雨蕭瑟，景色荒涼，憂國懷鄉，感極而悲。'
          },
          {
            question: '「不以物喜，不以己悲」有何意義？（2分）',
            answer: '這句話指古仁人不因外在環境或個人際遇而喜怒哀樂，能保持曠達胸襟。作者勉勵眾人效法此操守。'
          },
          {
            question: '「先天下之憂而憂，後天下之樂而樂」是什麼精神？（3分）',
            answer: '這是憂國憂民、以天下為己任的精神，作者主張身為官員應以百姓之憂為己憂，以天下人之樂為己樂，體現無私奉獻的高尚情操。'
          },
          {
            question: '「銜遠山，吞長江，浩浩湯湯，橫無際涯」運用了什麼修辭手法？其作用是什麼？（4分）',
            answer: '這運用了比喻和誇張手法，把洞庭湖比作吞納長江，浩渺無際，強調湖面壯闊壯美，讓人印象深刻。'
          },
          {
            question: '「噫！微斯人，吾誰與歸！」一句有何含意？',
            answer: '表示作者嚮往古仁人之境界，認為世間若無此等人，自己便無所依歸。抒發了自我理想與政治抱負。'
          }
        ]
      }
    }
  },
  'hkdse-d2-liuzongyuan-xishan-yanyou-ji': {
    title: '柳宗元《始得西山宴遊記》問答題精選',
    sections: {
      paragraphStructure: {
        title: '段落重點整理',
        content: [
          {
            subtitle: '第一段：背景與遊歷心境',
            points: [
              {
                title: '內容重點',
                items: [
                  '交代作者被貶永州，心情憂懼，常藉遊山水排遣鬱悶。',
                  '平日與同伴登山遊覽，雖自認已遊遍永州山水，但未識西山之奇特。',
                  '平日遊覽結束後，內心仍未真正開闊，未得解脫。'
                ]
              }
            ]
          },
          {
            subtitle: '第二段：發現西山與心靈昇華',
            points: [
              {
                title: '內容重點',
                items: [
                  '記述某天坐於法華西亭，望見西山奇異，遂決定前往探遊。',
                  '描寫登臨西山的過程：過湘江、緣染溪、斫草燒茅、攀援而上，終至山巔。',
                  '俯視四周，景色壯闊，感受天地廣大，自己渺小。',
                  '在西山宴遊，心情極度暢快，醉而忘返，心神凝聚，形體釋放，與自然萬物融合為一。',
                  '體會到「始得」的真義，覺悟以往從未真正遊歷，今遊西山才是人生新的開端。'
                ]
              }
            ]
          }
        ]
      },
      centralTheme: {
        title: '文章主旨',
        content: [
          '藉記述發現及遊歷西山的經過，抒發自己形體心神的解放，與天地萬物融合的超脫境界。',
          '借西山超群特立，暗喻作者自視高潔，不與世俗同流，表達孤高獨特的志趣與情操。'
        ]
      },
      selectedQuestions: {
        title: '問答題精選',
        questions: [
          {
            question: '為什麼說作者「始遊」於西山？',
            answer: '作者雖常遊永州山水，但直到發現並登臨西山，才真正領略到天地之大與自身之渺小，心靈得以解放，故自覺以往未嘗真正遊歷，今始有「遊」的真義。'
          },
          {
            question: '作者遊西山時有什麼感受？',
            answer: '初登西山，俯瞰大地，感受景色壯闊浩瀚，自己如融於天地萬物之中，內心開朗超脫。宴遊之時，醉而忘返，心神凝聚，形體釋放，與大自然冥合，獲得精神自由。'
          },
          {
            question: '作者遊西山有何體會？',
            answer: '作者在西山宴遊後，體悟到自身與自然萬物合一，過往的煩憂得以釋放，精神上得到昇華。並明白以前的山水遊歷皆未臻其境，唯有西山才是真正「始得」的開始。'
          },
          {
            question: '作者如何描繪西山的景色？有何特色？',
            answer: '作者以「尺寸千里，攢蹙累積」、「縈青繚白，外與天際，四望如一」等描寫西山的高峻與壯闊，展現西山卓然獨立、氣象萬千，非一般小山可比。'
          },
          {
            question: '作者如何借景抒情／托物言志？',
            answer: '作者以西山之「特出」、「不與培塿為類」自況，寄意自身遭貶而不為世俗所用，卻自守高潔、不與流俗同流，表達孤高自賞的志節。'
          },
          {
            question: '文章如何運用襯托手法突出西山之高？',
            answer: '作者以永州其他山水作陪襯，先寫自己以為已遍歷群山，後發現西山獨特奇偉，以「俯視數州之土壤皆在衽席之下」等描寫，突出西山之高峻壯麗。'
          },
          {
            question: '作者遊歷永州其他地方時心境如何？',
            answer: '遊歷其他地方時，雖能暫時排遣煩憂，卻未得真正解脫，內心仍有憂慮。直到遊西山，心神始得超脫，與自然融合。'
          },
          {
            question: '作者如何表現「情景交融」？',
            answer: '作者站在西山之巔，因自然景色壯闊而心境豁然開朗，心凝形釋，與萬化冥合，情感隨景而生，達到情景交融的藝術境界。'
          },
          {
            question: '文章結構有何特點？',
            answer: '首尾呼應，結構嚴謹。首段伏筆「未始知西山之怪特」，尾段以「然後知吾嚮之未始遊，遊於是乎始」呼應，並以登西山為人生新起點，主題鮮明。'
          }
        ]
      }
    }
  }
};

export const getTypeDQAByTextId = (textId) => {
  return hkdseTypeDQAData[textId] || null;
}; 